export const extractHtmlTitle = html => {
    if (typeof html !== 'string') return '';

    const match = html.match(/<title[^>]*>([\s\S]*?)<\/title>/i);
    return match?.[1]?.trim() || '';
};

let originalTitle = typeof document !== 'undefined' ? document.title : '';

const injectParentTitleSyncScript = (html, title, originalTitle) => {
    if (typeof html !== 'string' || !title) {
        return html;
    }

    const syncScript = `<script>
(function(){
    try {
        var parentDoc = window.top.document;
        var originalTitle = ${JSON.stringify(originalTitle)};
        var newTitle = ${JSON.stringify(title)};
        parentDoc.title = newTitle;
        
        var restored = false;
        function restoreTitle() {
            if (restored) return;
            restored = true;
            if (originalTitle && parentDoc.title === newTitle) {
                parentDoc.title = originalTitle;
            }
        }
        
        window.addEventListener('unload', restoreTitle);
        window.addEventListener('pagehide', restoreTitle);
    } catch(e) {}
})();
</script>`;

    if (/<head[^>]*>/i.test(html)) {
        return html.replace(/<head([^>]*)>/i, `<head$1>${syncScript}`);
    }

    return `${syncScript}${html}`;
};

const normalizeHtmlSource = async htmlSource => {
    if (typeof htmlSource === 'string') {
        return htmlSource;
    }

    if (htmlSource instanceof Blob) {
        return await htmlSource.text();
    }

    return htmlSource;
};

export const createIframeReportBlobUrl = async htmlSource => {
    const normalizedHtml = await normalizeHtmlSource(htmlSource);
    const reportTitle = extractHtmlTitle(normalizedHtml);

    if (reportTitle && typeof document !== 'undefined') {
        if (document.title !== reportTitle) {
            originalTitle = document.title;
        }
        document.title = reportTitle;
    }

    const htmlWithParentTitleSync = injectParentTitleSyncScript(normalizedHtml, reportTitle, originalTitle);
    const blob = new Blob([htmlWithParentTitleSync], { type: 'text/html' });

    return {
        blobUrl: URL.createObjectURL(blob),
        title: reportTitle
    };
};
